import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { WorkerBillableItemType } from "../_types/worker-billable-item-type";

@Injectable({
    providedIn: 'root',
})
export class WorkerBillableItemTypesService extends Service<WorkerBillableItemType> {
    public override type = 'workerBillableItemTypes';
    public override url = 'invoicing/workerBillableItemTypes';
}
